/**
 * ToastPortal - Renders ToastContainer via React Portal
 * Place this once at the root of your app
 */

import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import type { ToastData } from './types';
import { ToastContainer } from './ToastContainer';
import { toastStore } from './toast-store';

export function ToastPortal() {
  const [toasts, setToasts] = useState<ToastData[]>([]);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    
    const unsubscribe = toastStore.subscribe(setToasts);
    return unsubscribe;
  }, [mounted]);

  const handleDismiss = useCallback((id: string) => {
    toastStore.dismiss(id);
  }, []);

  if (!mounted) {
    return null;
  }

  return createPortal(
    <ToastContainer toasts={toasts} onDismiss={handleDismiss} />,
    document.body
  );
}

